export default class UserProfile {
    constructor(options) {
        this.apiManager = options.apiManager;
    }
    getUserProfile({ types } = {}) {
        const params = {
            types
        };
        return this.apiManager.getUserTemplateInfo(params).then(res => {
            const data = res.Data || {};
            for (const type in data) {
                data[type] = {
                    id: data[type].TempId,
                    profile: data[type].Profile
                        ? JSON.parse(data[type].Profile)
                        : {}
                };
            }
            return data;
        });
    }
    saveUserProfile({ id, type, profile = {} }) {
        const action = id > 0 ? 'savetmp' : 'addtmp';
        const params = {
            type,
            profile: JSON.stringify(profile),
            action
        };
        if (action === 'addtmp') {
            params.auto_random_title = true;
        } else {
            params.tplId = id;
        }
        return this.apiManager
            .template(params, { method: 'post' })
            .then(res => {
                return res;
            });
    }
    getDrawings({ secId, eventType = 'ch_v4_draw' }) {
        const params = {
            action: 'loaddraw',
            secId,
            eventType
        };
        return this.apiManager.getUserComponentEvents(params).then(res => {
            const data = res.Data;
            if (data) {
                for (const eventType in data) {
                    data[eventType] = (data[eventType] || []).map(item => {
                        return {
                            info: item.EventInfo
                                ? JSON.parse(item.EventInfo)
                                : {},
                            id: item.EventId
                        };
                    });
                }
            }
            return data || {};
        });
    }
    saveDrawings({ secId, drawings, eventType = 'ch_v4_draw' }) {
        const params = {
            pid: secId,
            saveinfo: JSON.stringify(drawings),
            action: 'insertdraw',
            eventType
        };
        return this.apiManager
            .drawManager(params, { method: 'post' })
            .then(res => {
                return this._formatDrawing(res);
            });
    }
    removeDrawings({ drawId }) {
        const param = {
            drawid: drawId,
            action: 'removedraw'
        };
        return this.apiManager
            .drawManager(param, { method: 'get' })
            .then(res => {
                if (res !== true) {
                    throw new Error('Remove draw error');
                }
                return res;
            });
    }
    updateDrawings({ drawId, secId, info, eventType = 'ch_v4_draw' }) {
        const param = {
            drawid: drawId,
            action: 'updatedraw',
            pid: secId,
            eventType,
            saveinfo: JSON.stringify(info)
        };
        return this.apiManager
            .drawManager(param, { method: 'post' })
            .then(res => {
                return this._formatDrawing(res);
            });
    }
    _formatDrawing(res) {
        if (res && res.list) {
            return res.list.map(item => {
                return {
                    drawId: item.eventId,
                    info: item.eventInfo ? JSON.parse(item.eventInfo) : {}
                };
            });
        }
        return [];
    }
}
